angular.module('SpidApp')

.factory('SyncRunner',
        [  '$q'
         , '$rootScope'
         , '$http'
         
         , 'ConfigService'
         , 'LocalDistantAdapterFactory'
         , 'UserSyncService'
         , 'VacationSyncService'
         , 'CashSyncService'
         , 'BusinessDaySyncService'
         , 'ProductSyncService'
         , 'OperationalProductSyncService'
         , 'AgencySyncService'
         , 'OrderItemSyncService'
         , 'OrderSyncService'
         , 'OrderStatusSyncService'
         , 'SaleSyncService'
         
         , 'GenericFlusherSyncServiceFactory'
         , 'GenericSyncServiceFactory'
         , 'SyncConfig'
,function ( $q
         ,  $rootScope
         ,  $http
  
		 ,  ConfigService
		 ,  LocalDistantAdapterFactory
		 ,  UserSyncService
		 ,  VacationSyncService
		 ,  CashSyncService
		 ,  BusinessDaySyncService
		 ,  ProductSyncService
		 ,  OperationalProductSyncService
         ,  AgencySyncService
         ,  OrderItemSyncService
         ,  OrderSyncService
         ,  OrderStatusSyncService
         ,  SaleSyncService
  
         ,  GenericFlusherSyncServiceFactory
         ,  GenericSyncServiceFactory
         ,  SyncConfig
) {
  var SyncRunner = {
    _synchronizing   : false,
    isSynchronizing  : function () {
      return this._synchronizing
    },
    setSynchronizing : function (bool) {
      this._synchronizing = !!bool
    },

    _ascendUsers           : function (lastSyncIsoDate) {
      var Service = UserSyncService
      var Model   = 'User'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendVacations       : function (lastSyncIsoDate) {
      var Service = VacationSyncService
      var Model   = 'Vacation'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendCash            : function (lastSyncIsoDate) {
      var Service = CashSyncService
      var Model   = 'Cash'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendBusinessDays    : function (lastSyncIsoDate) {
      var Service = BusinessDaySyncService
      var Model   = 'BusinessDay'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendTransactions    : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/transactions', nodePushUrl: '/synchro/transactions', distantUrl: '/transactions'})
      var Model   = 'Transaction'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendOrder           : function (lastSyncIsoDate) {
      var Service = OrderSyncService
      var Model   = 'Order'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendOrderItem       : function (lastSyncIsoDate) {
      var Service = OrderItemSyncService
      var Model   = 'OrderItem'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendSales           : function (lastSyncIsoDate) {
      var Service = SaleSyncService
      var Model   = 'Sale'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendOrderStatus     : function (lastSyncIsoDate) {
      var Service = OrderStatusSyncService
      var Model   = 'OrderStatus'
      
      return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendMoneyTransfers  : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/money-transfers', nodePushUrl: '/synchro/money-transfers', distantUrl: '/money-transfers'})
        var Model   = 'MoneyTransfer'
        
        return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendCurrencyHistory : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/currency-history', nodePushUrl: '/synchro/currency-history', distantUrl: '/currency-history'})
        var Model   = 'CurrencyHistory'
        
        return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendInventories     : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/inventories', nodePushUrl: '/synchro/inventories', distantUrl: '/inventories'})
        var Model   = 'Inventory'
        
        return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendStocks    : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/stocks', nodePushUrl: '/synchro/stocks', distantUrl: '/stocks'})
        var Model   = 'Stock'
        return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendStockFlows    : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/stockflows', nodePushUrl: '/synchro/stockflows', distantUrl: '/stock-flows'})
        var Model   = 'StockFlow'
        return this._ascendX(lastSyncIsoDate, Service, Model)
    },
    _ascendX               : function (lastSyncIsoDate, Service, Model) {
      var count = null
      
      return Service.Node.getAllUnsync(lastSyncIsoDate).then(function (elems) {
        var formattedElems = _.map(elems, function (elem) {
          return LocalDistantAdapterFactory[Model].toDistantFormat(elem)
        })
        
        count = formattedElems.length

        return Service.Distant.pushAll(formattedElems)
      }).then(function (response) {
        console.logSyncUp(count + ' elements of ' + Model)
        return response
      })
    },

    _descendUsers              : function (lastSyncIsoDate) {
      var Service = UserSyncService
      var Model   = 'User'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendAgencies           : function (lastSyncIsoDate) {
      var Service = AgencySyncService
      var Model   = 'Agency'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendProducts           : function (lastSyncIsoDate) {
      var Service = ProductSyncService
      var Model   = 'Product'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendOperationalProduct : function (lastSyncIsoDate) {
        var Service = OperationalProductSyncService
        var Model   = 'OperationalProduct'
        
        return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendOrder              : function (lastSyncIsoDate) {
      var Service = OrderSyncService
      var Model   = 'Order'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendOrderItem          : function (lastSyncIsoDate) {
      var Service = OrderItemSyncService
      var Model   = 'OrderItem'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendSales              : function (lastSyncIsoDate) {
      var Service = SaleSyncService
      var Model   = 'Sale'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendStamps             : function (lastSyncIsoDate) {
      var metas = [
          { model: 'Affranchissement'                             , serviceParams: { nodePushUrl: '/synchro/affranchissement'                                , distantUrl: '/affranchissement'                                } }
        , { model: 'ChoixOptionAffranchissementDestination'       , serviceParams: { nodePushUrl: '/synchro/choix_option_affranchissement_destination'       , distantUrl: '/choix-option-affranchissement-destination'       } }
        , { model: 'ComplementServiceAffranchissementDestination' , serviceParams: { nodePushUrl: '/synchro/complement_service_affranchissement_destination' , distantUrl: '/complement-service-affranchissement-destination' } }
        , { model: 'Destination'                                  , serviceParams: { nodePushUrl: '/synchro/destination'                                     , distantUrl: '/destination'                                     } }
        , { model: 'DestinationZone'                              , serviceParams: { nodePushUrl: '/synchro/destination_zone'                                , distantUrl: '/destination-zone'                                } }
        , { model: 'OptionAffranchissementDestination'            , serviceParams: { nodePushUrl: '/synchro/option_affranchissement_destination'             , distantUrl: '/option-affranchissement-destination'             } }
        , { model: 'PrixServiceAffranchissementDestination'       , serviceParams: { nodePushUrl: '/synchro/prix_service_affranchissement_destination'       , distantUrl: '/prix-service-affranchissement-destination'       } }
        , { model: 'PrixTrancheAffranchissementZone'              , serviceParams: { nodePushUrl: '/synchro/prix_tranche_affranchissement_zone'              , distantUrl: '/prix-tranche-affranchissement-zone'              } }
        , { model: 'Restriction'                                  , serviceParams: { nodePushUrl: '/synchro/restriction'                                     , distantUrl: '/restriction'                                     } }
        , { model: 'ServiceAffranchissementDestination'           , serviceParams: { nodePushUrl: '/synchro/service_affranchissement_destination'            , distantUrl: '/service-affranchissement-destination'            } }
        , { model: 'ZoneAffranchissement'                         , serviceParams: { nodePushUrl: '/synchro/zone_affranchissement'                           , distantUrl: '/zone-affranchissement'                           } }
      ]
      
      var self = this
      var promises = []
      
      metas.forEach(function (meta) {
        promises.push( self._descendX(lastSyncIsoDate, GenericFlusherSyncServiceFactory(meta.serviceParams), meta.model) )
      })
      
      return $q.all(promises).then(function () {
        return {stamps: 'OK'}
      })
    },
    _descendCash               : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/cash', nodePushUrl: '/synchro/cash', distantUrl: '/cash'})
      var Model   = 'Cash'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendVacations          : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/vacations', nodePushUrl: '/synchro/vacations', distantUrl: '/vacations'})
      var Model   = 'Vacation'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendBusinessDay        : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/business-days', nodePushUrl: '/synchro/business-days', distantUrl: '/businessdays'})
      var Model   = 'BusinessDay'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendTransactions       : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/transactions', nodePushUrl: '/synchro/transactions', distantUrl: '/transactions'})
      var Model   = 'Transaction'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendOrders             : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/orders', nodePushUrl: '/orders', distantUrl: '/orders'})
      var Model   = 'Order'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendOrderItems         : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/orderItems', nodePushUrl: '/orderItems', distantUrl: '/order-items'})
      var Model   = 'OrderItem'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendOrderStatus        : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/orderStatus', nodePushUrl: '/orderStatus', distantUrl: '/order-status'})
      var Model   = 'OrderStatus'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendCurrencies         : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/currencies', nodePushUrl: '/synchro/currencies', distantUrl: '/currencies'})
      var Model   = 'Currency'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendMoneyTransfers     : function (lastSyncIsoDate) {
      var Service = GenericSyncServiceFactory({nodeFetchUrl: '/money-transfers', nodePushUrl: '/synchro/money-transfers', distantUrl: '/money-transfers'})
      var Model   = 'MoneyTransfer'
      
      return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendCurrencyHistory    : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/currency-history', nodePushUrl: '/synchro/currency-history', distantUrl: '/currency-history'})
        var Model   = 'CurrencyHistory'
        
        return this._descendX(lastSyncIsoDate, Service, Model)
     },
    _descendInventories        : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/inventories', nodePushUrl: '/synchro/inventories', distantUrl: '/inventories'})
        var Model   = 'Inventory'
        
        return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendStocks       : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/stocks', nodePushUrl: '/synchro/stocks', distantUrl: '/stocks'})
        var Model   = 'Stock'
        
        return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendStockFlows       : function (lastSyncIsoDate) {
        var Service = GenericSyncServiceFactory({nodeFetchUrl: '/stockflows', nodePushUrl: '/synchro/stockflows', distantUrl: '/stock-flows'})
        var Model   = 'StockFlow'
        
        return this._descendX(lastSyncIsoDate, Service, Model)
    },
    _descendX                  : function (lastSyncIsoDate, service, model) {
      var count = null
      
      var Model = model
      var Service = service
      
      return Service.Distant.getAllUnsync(lastSyncIsoDate).then(function (elems) {
        count = elems.length
        
        var formattedElems = _.map(elems, function (elem) {
          return LocalDistantAdapterFactory[Model].toLocalFormat(elem)
        })

        return Service.Node.pushAll(formattedElems)
      }).then(function (response) {
        console.logSyncDown(count + ' elements of ' + Model)
        return response
      })
    },

    ascend1  : function (lastSyncIsoDate) {
      var self = this

      return $q.all([
        self._ascendUsers(lastSyncIsoDate).then(function (e) {
          console.logSyncUp('up users', e)

          return $q.all([
            self._ascendCash(lastSyncIsoDate).then(function (e) {
              console.logSyncUp('up vacations', e)

              return self._ascendVacations(lastSyncIsoDate).then(function (e) {
                console.logSyncUp('up cash', e)
              })
            }),
            self._ascendBusinessDays(lastSyncIsoDate) 	.then(function (e) { console.logSyncUp('up business-days', e) 			}),
            self._ascendTransactions(lastSyncIsoDate) 	.then(function (e) { console.logSyncUp('up transaction', e)   			})


          ])
          
        })
      ])
    },
    ascend2  : function (lastSyncIsoDate) {
      var self = this

      return $q.all([
          self._ascendSales(lastSyncIsoDate)        	.then(function (e) { console.logSyncUp('up sales', e)         			})
      ])
    },
    ascend3  : function (lastSyncIsoDate) {
      var self = this

      return $q.all([
          self._ascendOrder(lastSyncIsoDate)        	.then(function (e) { console.logSyncUp('up order', e)         			}),
          self._ascendOrderItem(lastSyncIsoDate)    	.then(function (e) { console.logSyncUp('up order-item', e)    			}),
          self._ascendOrderStatus(lastSyncIsoDate)  	.then(function (e) { console.logSyncUp('up order-status', e)  			})

      ])
    },ascend4  : function (lastSyncIsoDate) {
      var self = this

      return $q.all([
        self._ascendMoneyTransfers(lastSyncIsoDate) .then(function (e) { console.logSyncUp('up money-transfers', e)   		}),
        self._ascendCurrencyHistory(lastSyncIsoDate).then(function (e) { console.logSyncUp('up currency-history', e)        }),
        self._ascendInventories(lastSyncIsoDate)    .then(function (e) { console.logSyncUp('up inventories', e)             }),
        self._ascendStocks(lastSyncIsoDate) 		.then(function (e) { console.logSyncUp('up stocks', e)   				}),
        self._ascendStockFlows(lastSyncIsoDate) 	.then(function (e) { console.logSyncUp('up stockflows', e)   			})
      ])
    },


    /***********************************************************    DESCEND      **********************************************************************/
    descend1 : function (lastSyncIsoDate) {
          var self = this

          return $q.all([
                self._descendAgencies(lastSyncIsoDate)          .then(function (e) { console.logSyncDown('down agencies', e) }, function (e) { console.logSyncDown('error down agencies', e)                          })
              , self._descendUsers(lastSyncIsoDate)             .then(function (e) { console.logSyncDown('down users', e) }, function (e) { console.logSyncDown('error down users', e)                                })
              , self._descendProducts(lastSyncIsoDate)          .then(function (e) { console.logSyncDown('down products', e) }, function (e) { console.logSyncDown('error down products', e)                          })
              , self._descendOperationalProduct(lastSyncIsoDate).then(function (e) { console.logSyncDown('down operational-products', e) }, function (e) { console.logSyncDown('error down operational-products', e)  })
          ])
    },descend2 : function (lastSyncIsoDate) {
        var self = this

        return $q.all([
            self._descendStamps(lastSyncIsoDate)            .then(function (e) { console.logSyncDown('down stamps', e) }, function (e) { console.logSyncDown('error down stamps', e) })
        ])

    },descend3 : function (lastSyncIsoDate) {
      var self = this

      return $q.all([
          self._descendOrder(lastSyncIsoDate)               .then(function (e) { console.logSyncDown('down order', e) }, function (e) { console.logSyncDown('error down order', e)                          })
          , self._descendOrderStatus(lastSyncIsoDate)       .then(function (e) { console.logSyncDown('down order status', e) }, function (e) { console.logSyncDown('error down order status', e)                          })
          , self._descendOrderItem(lastSyncIsoDate)         .then(function (e) { console.logSyncDown('down order item', e) }, function (e) { console.logSyncDown('error down order item', e)                          })
      ])

    },descend4 : function (lastSyncIsoDate) {
          var self = this
          return $q.all([
              self._descendSales(lastSyncIsoDate)             .then(function (e) { console.logSyncDown('down sales', e) }, function (e) { console.logSyncDown('error down sales', e)                          })
          ])

    },descend5 : function (lastSyncIsoDate) {
        var self = this

        return $q.all([
            self._descendCash(lastSyncIsoDate)              .then(function (e) { console.logSyncDown('down cash', e) }, function (e) { console.logSyncDown('error down cash', e)                          })
        ])

    },descend6 : function (lastSyncIsoDate) {
        var self = this

        return $q.all([
            self._descendVacations(lastSyncIsoDate)         .then(function (e) { console.logSyncDown('down vacations', e) }, function (e) { console.logSyncDown('error down vacations', e)                          })
        ])

    },descend7 : function (lastSyncIsoDate) {
        var self = this

        return $q.all([
            self._descendBusinessDay(lastSyncIsoDate)       .then(function (e) { console.logSyncDown('down business-day', e) }, function (e) { console.logSyncDown('error down business-day', e)                          })
        ])

    },descend8 : function (lastSyncIsoDate) {
        var self = this

        return $q.all([
            self._descendTransactions(lastSyncIsoDate)      .then(function (e) { console.logSyncDown('down transactions', e) }, function (e) { console.logSyncDown('error down transactions', e)                          })
        ])

    },descend9 : function (lastSyncIsoDate) {
        var self = this
        return $q.all([
              self._descendCurrencies(lastSyncIsoDate)        .then(function (e) { console.logSyncDown('down currencies', e) }, function (e) { console.logSyncDown('error down currencies', e)                          })
            , self._descendMoneyTransfers(lastSyncIsoDate)    .then(function (e) { console.logSyncDown('down money-transfers', e) }, function (e) { console.logSyncDown('error down money-transfers', e)                          })
        ])

    },descend10 : function (lastSyncIsoDate) {
      var self = this

      return $q.all([
          self._descendCurrencyHistory(lastSyncIsoDate)       .then(function (e) { console.logSyncDown('down currency-history', e) }, function (e) { console.logSyncDown('error down currency-history', e)                          })
          , self._descendInventories(lastSyncIsoDate)         .then(function (e) { console.logSyncDown('down inventories', e) }, function (e) { console.logSyncDown('error down inventories', e)                          })
          , self._descendStocks(lastSyncIsoDate) 			  .then(function (e) { console.logSyncDown('down stocks', e) }, function (e) { console.logSyncDown('error down stocks', e)                          })
          , self._descendStockFlows(lastSyncIsoDate) 		  .then(function (e) { console.logSyncDown('down stockflows', e) }, function (e) { console.logSyncDown('error down stockflows', e)                          })
      ])

    },

    checkin : function (agencyId) {
      if (agencyId === null || agencyId === undefined) {
        throw 'SyncRunner::checkin() - Missing parameters'
      }
      
      var distantAuthorization = SyncConfig.Distant.Authorization
  
      var req = { method: 'POST', url: SyncConfig.Distant.getURLFor('/checkin'), headers: { 'Authorization': distantAuthorization }, data: {agencyId: agencyId} }
      return $http(req)
    },
    
    sync: function (successCb, errorCb) {
      successCb = successCb || function () {}
      errorCb   = errorCb   || function (error) {
        console.error(error)
      }
      
      var self = this
      self.setSynchronizing(true)

      console.time('sync')
      var lastSyncIsoDate = null
      return ConfigService.all().then(function (config) {
    	$rootScope.$broadcast('loading',[true]);
    	$rootScope.isSyncRunning = true;
        lastSyncIsoDate = config.lastSyncIsoDate

        return self.ascend1(lastSyncIsoDate).then(function () {
          console.logSyncUp('Sync up 1 OK')
        })
      }).then(function () {
        return self.ascend2(lastSyncIsoDate).then(function () {
          console.logSyncUp('Sync up 2 OK')
        })
      }).then(function () {
        return self.ascend3(lastSyncIsoDate).then(function () {
          console.logSyncUp('Sync up 3 OK')
        })
      }).then(function () {
        return self.ascend4(lastSyncIsoDate).then(function () {
          console.logSyncUp('Sync up 4 OK')
        })
/***************************   descend   **************************/
      }).then(function () {
        return self.descend1(lastSyncIsoDate).then(function () {
          console.logSyncDown('Sync down 1 OK')
        })
      }).then(function () {
        return self.descend2(lastSyncIsoDate).then(function () {
          console.logSyncDown('Sync down 2 OK')
        })
      }).then(function () {
        return self.descend3(lastSyncIsoDate).then(function () {
          console.logSyncDown('Sync down 3 OK')
        })
      }).then(function () {
        return self.descend4(lastSyncIsoDate).then(function () {
          console.logSyncDown('Sync down 4 OK')
        })
      }).then(function () {
          return self.descend5(lastSyncIsoDate).then(function () {
              console.logSyncDown('Sync down 5 OK')
          })
      }).then(function () {
          return self.descend6(lastSyncIsoDate).then(function () {
              console.logSyncDown('Sync down 6 OK')
          })
      }).then(function () {
          return self.descend7(lastSyncIsoDate).then(function () {
              console.logSyncDown('Sync down 7 OK')
          })
      }).then(function () {
          return self.descend8(lastSyncIsoDate).then(function () {
              console.logSyncDown('Sync down 8 OK')
          })
      }).then(function () {
          return self.descend9(lastSyncIsoDate).then(function () {
              console.logSyncDown('Sync down 9 OK')
          })
      }).then(function () {
          return self.descend10(lastSyncIsoDate).then(function () {
              console.logSyncDown('Sync down 10 OK')
          })

      }).then(function () {
        var last_sync_iso_date = new Date().toISOString();
        console.log('last_sync_iso_date',last_sync_iso_date)
        return ConfigService.save('last_sync_iso_date', last_sync_iso_date)

      }).then(function () {
        successCb()
        
      }).catch(function (error) {
        errorCb(error)
        
      }).finally(function () {
        self.setSynchronizing(false)
        $rootScope.$broadcast('loading', [false]);
        $rootScope.isSyncRunning = false;
        console.timeEnd('sync')
      })
    }
  }

  return SyncRunner
}])